export const initSlider = ({
  sliderContainerId,
  sliderPrevButtonClass,
  sliderNextButtonClass,
  hideButtonClass,
}) => {
  const sliderContainer = document.getElementById(sliderContainerId);
  const scrollBehaviourLuft = 5;

  if (sliderContainer) {
    const itemsCollection = sliderContainer.children;
    const prevBtn = sliderContainer.parentElement.getElementsByClassName(
      sliderPrevButtonClass,
    )[0];
    const nextBtn = sliderContainer.parentElement.getElementsByClassName(
      sliderNextButtonClass,
    )[0];

    const getMoveData = () => {
      const itemWidth = itemsCollection[0].clientWidth;
      const itemsCount = itemsCollection.length;
      const currentScroll = sliderContainer.scrollLeft;
      const scrolledCount = Math.floor(
        (currentScroll + scrollBehaviourLuft) / itemWidth,
      );
      const isPossibleToScrollNext = scrolledCount < itemsCount - 2;
      const isPossibleToScrollPrev = scrolledCount > 0;

      return {
        isPossibleToScrollNext,
        isPossibleToScrollPrev,
        itemWidth,
        scrolledCount,
      };
    };

    const moveNext = () => {
      const { isPossibleToScrollNext, itemWidth, scrolledCount } =
        getMoveData();

      if (isPossibleToScrollNext) {
        const targetScroll = (scrolledCount + 1) * itemWidth;

        sliderContainer.scrollTo({
          left: targetScroll,
          behavior: 'smooth',
        });
      }
    };

    const movePrev = () => {
      const { isPossibleToScrollPrev, itemWidth, scrolledCount } =
        getMoveData();

      if (isPossibleToScrollPrev) {
        sliderContainer.scrollTo({
          left: (scrolledCount - 1) * itemWidth,
          behavior: 'smooth',
        });
      }
    };

    if (itemsCollection.length < 4) {
      prevBtn.classList.add(hideButtonClass);
      nextBtn.classList.add(hideButtonClass);
    } else {
      if (nextBtn) {
        nextBtn.addEventListener('click', moveNext);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', movePrev);
      }
    }
  }
};
